import React, { useState, useEffect } from 'react';
import api from '../../api';
import './Admin.css';

const STATUSES = ['pending','confirmed','dispatched','cancelled'];
const STATUS_COLORS = { pending:'badge-warning', confirmed:'badge-success', dispatched:'badge-terracotta', cancelled:'badge-error' };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  const load = () => api.get('/admin/orders').then(r => { setOrders(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => { await api.patch(`/admin/orders/${id}/status`, { status }); load(); };

  return (
    <div className="admin-page">
      <div className="admin-page-header"><h1 className="admin-page-title">Orders</h1></div>
      {loading ? <div className="page-loading"><div className="spinner" /></div> : (
        <table className="admin-table">
          <thead><tr><th>Order ID</th><th>Company</th><th>Customer</th><th>Total</th><th>Date</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {orders.map(o => (
              <React.Fragment key={o._id}>
                <tr>
                  <td>
                    <button onClick={() => setExpanded(expanded === o._id ? null : o._id)} style={{background:'none',border:'none',cursor:'pointer',fontFamily:'var(--font-serif)',fontSize:'15px',color:'var(--terracotta)'}}>
                      #{o._id.slice(-8).toUpperCase()} {expanded === o._id ? '▲' : '▼'}
                    </button>
                  </td>
                  <td><strong>{o.company_name}</strong></td>
                  <td>{o.full_name}<br/><span style={{fontSize:'11px',color:'var(--gray)'}}>{o.email}</span></td>
                  <td><strong>£{Number(o.total_amount).toFixed(2)}</strong></td>
                  <td style={{fontSize:'12px',color:'var(--gray)'}}>{new Date(o.createdAt).toLocaleDateString('en-GB')}</td>
                  <td><span className={`badge ${STATUS_COLORS[o.status]||'badge-gray'}`}>{o.status}</span></td>
                  <td>
                    <select value={o.status} onChange={e => updateStatus(o._id, e.target.value)} style={{fontSize:'12px',padding:'6px 10px',width:'auto'}}>
                      {STATUSES.map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
                    </select>
                  </td>
                </tr>
                {expanded === o._id && (
                  <tr>
                    <td colSpan="7" style={{background:'var(--cream)',padding:'16px 24px'}}>
                      <strong style={{fontSize:'12px',letterSpacing:'1px',textTransform:'uppercase',color:'var(--gray)'}}>Order Items</strong>
                      <table style={{width:'100%',marginTop:'10px',borderCollapse:'collapse'}}>
                        <thead><tr style={{fontSize:'11px',color:'var(--gray)'}}>
                          <th style={{textAlign:'left',padding:'4px 8px'}}>Product</th>
                          <th style={{textAlign:'center',padding:'4px 8px'}}>Qty</th>
                          <th style={{textAlign:'right',padding:'4px 8px'}}>Unit Price</th>
                          <th style={{textAlign:'right',padding:'4px 8px'}}>Subtotal</th>
                        </tr></thead>
                        <tbody>
                          {o.items?.map(item => (
                            <tr key={item._id} style={{fontSize:'13px',borderTop:'1px solid var(--gray-light)'}}>
                              <td style={{padding:'8px'}}>{item.product_name}</td>
                              <td style={{padding:'8px',textAlign:'center'}}>{item.quantity}</td>
                              <td style={{padding:'8px',textAlign:'right'}}>£{Number(item.unit_price).toFixed(2)}</td>
                              <td style={{padding:'8px',textAlign:'right',fontWeight:'500'}}>£{(item.unit_price*item.quantity).toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {o.notes && <p style={{marginTop:'12px',fontSize:'13px',color:'var(--gray)'}}>Notes: {o.notes}</p>}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
            {orders.length === 0 && <tr><td colSpan="7" style={{textAlign:'center',padding:'32px',color:'var(--gray)'}}>No orders yet.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
